import * as React from "react";

export function useForceUpdate() {
  const [, set] = React.useState(() => Object.create(null));
  const forceUpdate = React.useCallback(() => {
    set(Object.create(null));
  }, []);
  return forceUpdate;
}
